/**
 * Global styles and mode utilities
 * Following AWS-UI-Examples pattern
 */

import { applyMode, Mode } from '@amzn/awsui-global-styles';

// Import global styles - this is the key import for fonts and styling
import '@amzn/awsui-global-styles/polaris.css';

// Initialize with light mode
applyMode(Mode.Light);

export { Mode };
export { applyMode };
